import React from 'react';
import { Button, Space } from 'antd';
import { ManOutlined, WomanOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import ChoiceCard from './ChoiceCard';
import { signupGradient } from './signupTheme';
import type { ParentRole } from '../../../api/auth/signup';

type Props = {
    value?: ParentRole;
    onChange: (role: ParentRole) => void;
    onContinue: () => void;
};

/** Étape 2 — papa ou maman. */
const StepParentRole: React.FC<Props> = ({ value, onChange, onContinue }) => {
    const { t } = useTranslation();

    return (
        <Space direction="vertical" size={24} style={{ width: '100%' }}>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                <ChoiceCard
                    icon={<ManOutlined />}
                    label={t('signup.parentRole.father', 'Papa')}
                    selected={value === 'father'}
                    onSelect={() => onChange('father')}
                />
                <ChoiceCard
                    icon={<WomanOutlined />}
                    label={t('signup.parentRole.mother', 'Maman')}
                    selected={value === 'mother'}
                    onSelect={() => onChange('mother')}
                />
            </div>

            <Button
                type="primary"
                size="large"
                block
                disabled={!value}
                onClick={onContinue}
                style={{ height: 52, borderRadius: 12, border: 'none', background: signupGradient, fontWeight: 600, fontSize: 16 }}
            >
                {t('signup.actions.continue', 'Continuer')}
            </Button>
        </Space>
    );
};

export default StepParentRole;
